import ProfilePicture from "./profile-picture";

export default ProfilePicture;
